import React from "react";
import SubmissionRouter from './Submission/Router';
export { getFields, getReplyFields } from './Submission/Router';

export default function SubmissionsPmRouter(props){
    return <SubmissionRouter {...props} mode='SUPPLIER' />;
}